import React from 'react'

import AddTagForm from '../../modules/Tag/components/AddTagForm'
export default function AddTagPage() {
  return <AddTagForm />
}
